import { mount } from 'svelte';
import { waitLocale } from 'svelte-i18n';
import App from './App.svelte';
import { setupI18n } from './lib/i18n';
import './app.css';

setupI18n();

const target = document.getElementById('app');
if (!target) {
	throw new Error('Mount target #app not found in document.');
}

// svelte-i18n's init() lazy-loads the initial locale JSON over the network;
// calling `$_(key)` before it resolves throws "Cannot format a message
// without first setting the initial locale". waitLocale() resolves once the
// initial dictionary is in memory — only then is it safe to mount.
waitLocale().then(() => {
	mount(App, { target });
});
